import axios from 'axios';

// Remove trailing slash if present
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1').replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

const getAuthHeadersMultipart = () => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };
};

/**
 * Public: Get ads configured for a specific page in Chesswyze web app
 * GET /api/v1/ads?page={page}
 */
export const getAdsForPage = async (page) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/ads`, {
      params: { page },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Super Admin: List all ads with pagination
 * GET /api/v1/ads/admin?page=1&limit=10
 */
export const getAdminAds = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/ads/admin`, {
      ...getAuthHeaders(),
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Super Admin: Get single ad details by id
 * GET /api/v1/ads/admin/:id
 */
export const getAdminAdById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/ads/admin/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Super Admin: Create a new ad
 * POST /api/v1/ads
 * Body: FormData containing title, mediaType, pages, slots, linkUrl, altText, media, mobileMedia
 */
export const createAd = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/ads`, formData, getAuthHeadersMultipart());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Super Admin: Update an existing ad
 * PATCH /api/v1/ads/:id
 */
export const updateAd = async (id, formData) => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/ads/${id}`, formData, getAuthHeadersMultipart());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Super Admin: Delete an ad by id
 * DELETE /api/v1/ads/:id
 */
export const deleteAd = async (id) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/ads/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
